// Jakaa työmaalistan v-selectin otsikko- ja jakajariveillä ryhmiin: suosikit, viimeksi käytetyt
// (recentIds-järjestyksessä, ilman suosikkeja) ja muut. Tyhjät ryhmät jätetään pois; jos vain "muut"
// jää, lista palautetaan sellaisenaan. isFavorite-funktiolla ryhmittely voidaan jäädyttää valikon
// ollessa auki (ks. frozenFavoriteCheck).
export function groupSites(sites, t, { isFavorite = s => s.favorite, recentIds = [] } = {}) {
  const favorites = sites.filter(isFavorite);
  const recent = recentIds.map(id => sites.find(s => s.id === id)).filter(s => s && !isFavorite(s));
  if (!favorites.length && !recent.length) return sites;
  const others = sites.filter(s => !isFavorite(s) && !recent.includes(s));
  const groups = [
    [t('sites.favorites'), favorites],
    [t('sites.recently_used'), recent],
    [t('sites.other_sites'), others],
  ].filter(([, items]) => items.length);
  return groups.flatMap(([header, items], index) => [...(index > 0 ? [{ divider: true }] : []), { header }, ...items]);
}

// Suosikkitarkistus, joka muistaa tämänhetkiset suosikit. Käytetään valikon ollessa auki, jotta tähden
// napsautus ei siirrä riviä heti toiseen ryhmään; ryhmittely päivittyy, kun valikko avataan uudelleen.
export function frozenFavoriteCheck(sites) {
  const ids = new Set(sites.filter(s => s.favorite).map(s => s.id));
  return s => ids.has(s.id);
}
